/*
  Cart drawer upsells: order protection toggle and the partner pair add.

  Listeners are delegated from document because cart-drawer.js replaces the
  innerHTML of #CartDrawer on every cart change - anything bound directly to
  these buttons would be dead after the first interaction.
*/
(function () {
  'use strict';

  var BUSY = false;

  function sectionUrl() {
    return window.location.pathname;
  }

  // Mirrors what cart-drawer.js does, so the drawer updates without a reload.
  function renderDrawer(state, keepClosed) {
    var html = state && state.sections && state.sections['cart-drawer'];
    if (!html) {
      window.location.reload();
      return;
    }
    var parsed = new DOMParser().parseFromString(html, 'text/html');
    var fresh = parsed.querySelector('#CartDrawer');
    var live = document.querySelector('#CartDrawer');
    if (fresh && live) live.innerHTML = fresh.innerHTML;

    var bubbleHtml = state.sections['cart-icon-bubble'];
    var bubble = document.getElementById('cart-icon-bubble');
    if (bubbleHtml && bubble) {
      var b = new DOMParser().parseFromString(bubbleHtml, 'text/html').querySelector('.shopify-section');
      if (b) bubble.innerHTML = b.innerHTML;
    }

    var drawer = document.querySelector('cart-drawer');
    if (!keepClosed && drawer && typeof drawer.open === 'function') drawer.open();
    document.dispatchEvent(new CustomEvent('cd:upsell-updated'));
  }

  function fail(control) {
    if (control) control.removeAttribute('disabled');
    BUSY = false;
    var box = document.querySelector('#CartDrawer-CartErrors');
    if (box) box.textContent = 'We could not update your cart. Please try again.';
  }

  function post(url, body, control) {
    // returns the promise so callers that chain a second request (the
    // one-time/subscribe swap) can see a failure
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    })
      .then(function (r) { return r.json(); })
      .then(function (state) {
        if (state.status || state.errors) { fail(control); return; }
        BUSY = false;
        renderDrawer(state);
      })
      .catch(function () { fail(control); });
  }

  document.addEventListener('click', function (e) {
    if (BUSY) return;

    /* ---- one-time vs subscribe ---- */
    var opt = e.target.closest('.cd-opt');
    if (opt) {
      e.preventDefault();
      var orow = opt.closest('[data-cd-addon]');
      if (!orow) return;
      var mode = opt.getAttribute('data-mode');
      if (orow.getAttribute('data-mode') === mode) return;

      // the selection answers immediately; the cart follows only if there is
      // already a line to move
      orow.setAttribute('data-mode', mode);
      [].forEach.call(orow.querySelectorAll('.cd-opt'), function (b) {
        var on = b.getAttribute('data-mode') === mode;
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', String(on));
      });
      var terms = orow.querySelector('.cd-up__d');
      if (terms) terms.hidden = (mode !== 'sub');

      if (orow.getAttribute('data-in-cart') !== 'true') return;

      // swapping the mode means replacing the line: a selling plan cannot be
      // changed on a line that already exists
      BUSY = true;
      opt.setAttribute('disabled', '');
      var line = { id: Number(orow.getAttribute('data-variant')), quantity: 1 };
      var plan = Number(orow.getAttribute('data-plan'));
      if (mode === 'sub' && plan > 0) line.selling_plan = plan;
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: orow.getAttribute('data-key'), quantity: 0 }),
      })
        .then(function () {
          return post('/cart/add.js', {
            items: [line],
            sections: 'cart-drawer,cart-icon-bubble',
            sections_url: sectionUrl(),
          }, opt);
        })
        .catch(function () { fail(opt); });
      return;
    }

    /* ---- order protection ---- */
    var toggle = e.target.closest('.cd-tg');
    if (toggle) {
      // the saline refill row now uses an Add button, not this switch
        var row = toggle.closest('[data-cd-op], [data-cd-addon]');
      if (!row) return;
      e.preventDefault();
      BUSY = true;
      toggle.setAttribute('disabled', '');

      var on = row.getAttribute('data-in-cart') === 'true';
      // optimistic: the switch moves immediately, the cart catches up
      toggle.classList.toggle('is-on', !on);
      toggle.setAttribute('aria-checked', String(!on));

      if (on) {
        post('/cart/change.js', {
          id: row.getAttribute('data-key'),
          quantity: 0,
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: sectionUrl(),
        }, toggle);
      } else {
        post('/cart/add.js', {
          items: [(function () {
              var line = { id: Number(row.getAttribute('data-variant')), quantity: 1 };
              var plan = Number(row.getAttribute('data-plan'));
              // only subscribe when that is the selection; rows with no choice
              // on offer carry no data-mode and stay one-time
              if (plan > 0 && row.getAttribute('data-mode') === 'sub') line.selling_plan = plan;
              return line;
            })()],
          sections: 'cart-drawer,cart-icon-bubble',
          sections_url: sectionUrl(),
        }, toggle);
      }
      return;
    }

    /* ---- plain "Add" buttons: partner pair, saline refill ---- */
    var add = e.target.closest('[data-cd-add]');
    if (add) {
      e.preventDefault();
      BUSY = true;
      add.setAttribute('disabled', '');
      var addLine = { id: Number(add.getAttribute('data-variant')), quantity: 1 };
      // carried so a row that is later given a selling plan subscribes rather
      // than silently adding the one-time variant
      var addPlan = Number(add.getAttribute('data-plan'));
      if (addPlan > 0) addLine.selling_plan = addPlan;
      post('/cart/add.js', {
        items: [addLine],
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: sectionUrl(),
      }, add);
    }
  });

  /*
    The drawer is rendered server-side with the cart as it was at that moment.
    Restore a page from the back/forward cache, or change the cart without
    re-rendering, and the gift panel can outlive the product it belongs to.
    Compare what the HTML assumed against the live cart and re-render if they
    disagree, so the drawer can never promise gifts for an absent product.
  */
  function reconcileOffer() {
    var marker = document.querySelector('#CartDrawer .cd-state');
    if (!marker) return;
    var handle = marker.getAttribute('data-gift-handle') || '';
    var rendered = marker.getAttribute('data-offer-live') === 'true';

    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var live = handle
          ? cart.items.some(function (i) { return i.handle === handle; })
          : cart.item_count > 0;
        if (live === rendered) return null;
        var path = sectionUrl();
        var url = path + (path.indexOf('?') > -1 ? '&' : '?') + 'sections=cart-drawer';
        return fetch(url, { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.json(); })
          .then(function (sections) { renderDrawer({ sections: sections }, true); });
      })
      .catch(function () { /* offline or blocked: leave the drawer as rendered */ });
  }

  window.addEventListener('pageshow', function (e) { if (e.persisted) reconcileOffer(); });
  var drawerEl = document.querySelector('cart-drawer');
  if (drawerEl && window.MutationObserver) {
    var wasOpen = drawerEl.classList.contains('active');
    new MutationObserver(function () {
      var isOpen = drawerEl.classList.contains('active');
      if (isOpen && !wasOpen) reconcileOffer();
      wasOpen = isOpen;
    }).observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
  }
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS === 'object' && PUB_SUB_EVENTS.cartUpdate) {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function () { setTimeout(reconcileOffer, 400); });
  }

  if (document.readyState !== 'loading') reconcileOffer();
  else document.addEventListener('DOMContentLoaded', reconcileOffer);
})();
